import React, {useState} from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import Zoom from '@material-ui/core/Zoom';
import Badge from '@material-ui/core/Badge';
import Chip from '@material-ui/core/Chip';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';

import Loading from '@base/Loading';

import {useStyles} from './Style';
import CollapsibleTable from "../../pages/Escola/Cartoes/componentes/CollapsibleTable";
import SearchIcon from "@material-ui/icons/Search";
import Collapse from "@material-ui/core/Collapse";
import {Grid} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

const DataTable = props => {
  const classes = useStyles();
  const {style, columns, tableData, actions, loading, page, rowsPerPage, sort, processo} = props;
  const [selected, setSelected] = useState([]);
  const [selecteds, setSelecteds] = useState([]);
  const [collapsedItems, setCollapsedItems] = useState([]);
  const [collapsed, setCollapsed] = useState(false);

  const handleCollapse = (id) => {
    setCollapsed(true)
    setCollapsedItems((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleRequestSort = (event, property) => {
    const sortable = sort ? sort.find(s => s.orderBy === property) : null
    const ordering = sortable && sortable.order === 'asc' ? 'desc' : 'asc';

    props.handleSort(property, ordering);
    props.handlePage(0);
  };

  const handleClearSort = (event, property) => {
    props.handleClearSort(property);
    props.handlePage(0);
  };

  const data = columnsFilter(columns, tableData);

  const handleSelectAllClick = (event) => {

    if (event.target.checked) {

      const newSelecteds = data.map(d => d.id);
      setSelected(newSelecteds);
      setSelecteds(data);
      props.handleChecks(newSelecteds, data);

      return;

    }

    setSelected([]);
    setSelecteds([]);
    props.handleChecks([]);

  };

  const getSortVerify = (name) => sort ? sort.find(s => s.orderBy === name) : null;

  const handleClick = (event, id, obj) => {

    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    let newSelecteds = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
      newSelecteds = [...selecteds, obj];
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      newSelecteds = selecteds.filter(s => s.id !== id);
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      newSelecteds = selecteds.filter(s => s.id !== id);
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
      newSelecteds = selecteds.filter(s => s.id !== id);
    }

    setSelected(newSelected);
    setSelecteds(newSelecteds);
    props.handleChecks(newSelected, newSelecteds);

  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  return (
    <>
      <Table style={style} className={classes.spacingTable} size='small'>
        {sort && sort.length > 0 &&
          <TableHead>
            <TableRow>
              <TableCell align="right" colSpan={columns.length + actions.length} rowSpan={2}>
                <Chip
                  label="Ordenação Padrão"
                  onDelete={() => handleClearSort(null)}
                />
              </TableCell>
            </TableRow>
          </TableHead>
        }
        <TableHead>
          <TableRow>
            {columns.map((c, i) => (
              !c.hidden ?
                c.item === 'checkbox' ?
                  props.handleChecks ?
                    <TableCell key={JSON.stringify(i)}>
                      <Checkbox
                        defaultChecked
                        color="primary"
                        indeterminate={selected.length > 0 && selected.length < data.length}
                        checked={data.length > 0 && selected.length === data.length}
                        onChange={event => handleSelectAllClick(event)}
                        inputProps={{'aria-label': 'Selecionar Todos'}}
                      />
                    </TableCell>
                    : null
                  :
                  <TableCell
                    key={JSON.stringify(i)}
                    className={classes.bolder}
                    padding='normal'
                    sortDirection={getSortVerify(c.filter ?? c.name) ? getSortVerify(c.filter ?? c.name).order : false}
                  >
                    {sort && c.ordering !== false ?
                      <Sort
                        column={c}
                        sort={getSortVerify(c.filter ?? c.name)}
                        sortLevel={sort.indexOf(getSortVerify(c.filter ?? c.name))}
                        requestSort={handleRequestSort}
                        clearSort={handleClearSort}
                        sizeSort={sort.length}
                      />
                      :
                      c.label
                    }
                  </TableCell>
                : <></>
            ))}
            {actions.some((action) => action.collapse) && <ActionCellHead action={actions[0]}/>}
            {actions.filter(action => !action.collapse).map((action, key) => <ActionCellHead action={action}
                                                                                             key={key}/>)}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ?
            <TableRow>
              <TableCell align="center" colSpan={columns.length + actions.length} rowSpan={2}>
                <Loading/>
              </TableCell>
            </TableRow>
            :
            data.length > 0 ?
              data.map((d, i) => {
                const isItemSelected = isSelected(d.id);
                const labelId = `enhanced-table-checkbox-${i}`;
                const isCollapsed = collapsedItems[d.id];
                return (
                  <>
                    <TableRow key={JSON.stringify(d.id)} hover>
                      {columns.map((c, i) => (
                        !c.hidden ?
                          c.item === 'checkbox' ?
                            props.handleChecks &&
                            <TableCell key={i} style={c.width ? {width: `${c.width}%`} : null}>
                              <Checkbox
                                defaultChecked
                                color="primary"
                                checked={isItemSelected}
                                onChange={event => handleClick(event, d.id, d)}
                                inputProps={{'aria-labelledby': labelId}}
                              />
                            </TableCell>
                            : <TableCell key={JSON.stringify(i)}
                                         style={{
                                           width: c.width ? `${c.width}%` : null,
                                           color: props.disableRowWhen && props.disableRowWhen(d['original']) ? "#bbb" : null
                                         }}>
                              <div>
                                {c.name === "tipoTratamentoNome" && d.original.tratamentoNome != null && d.original.tratamentoNome.tipo === "DUPLICADO_NA_ESCOLA" ?
                                  <div style={{cursor: "pointer"}}
                                       onClick={() => handleCollapse(d.id)}>{c.func ? c.func(d[c.name], d['original']) : d[c.name]}
                                    <SearchIcon style={{color: "#3f51b5"}}/>
                                  </div>
                                  : c.func ? c.func(d[c.name], d['original']) : d[c.name]
                                }
                              </div>
                            </TableCell>
                          : <></>
                      ))}
                      {actions.some((action) => action.collapse) &&
                        <CollapseActions id={d.id} object={d} actions={actions.filter(action => action.collapse)}/>}
                      {actions.filter(action => !action.collapse).map((action, key) => <ActionCellBody action={action}
                                                                                                       id={d.id}
                                                                                                       object={d}
                                                                                                       key={i}/>)}
                    </TableRow>
                    {collapsed &&
                      <TableCell colSpan={columns.length + actions.length} style={{border: "none"}} align={"center"}>
                        <Collapse style={{width: "100%"}} in={isCollapsed}>
                          <CollapsibleTable style={style} processo={processo} columns={columns} object={d}/>
                        </Collapse>
                      </TableCell>}

                  </>
                )
              })
          :
          <TableRow style={{height: 53}}>
            <TableCell colSpan={columns.length + actions.length} align="center">
              Não Foram Encontrados Registros para Exibição
            </TableCell>
          </TableRow>
          }
        </TableBody>
      </Table>
      {(props.rowsPerPage !== null && props.page != null) &&
      <Pagination
        page={page}
        loading={loading}
        changePage={props.handlePage}
        rowsPerPage={rowsPerPage}
        changeRowsPerPage={props.handleRowsPerPage}
        handleTotalElements={props.handleTotalElements}
        handleTotalPages={props.handleTotalPages}
        handleSelected={setSelected}
        rowsPerPageOptions={props.rowsPerPageOptions}
      />
      }
    </>
  )
}

  export const DataTableLineTotals = ({lineData, columns}) => {
    const classes = useStyles();

    const Cells = ({data, columns}) => {

      const Cell = () => columns.map((c, i) => {
        const d = data.find((d) => d.column === i);
        return d ? <TableCell style={d.width ? {width: `${d.width}%`} : null}>{d.value}</TableCell> :
          <TableCell></TableCell>
      })

      return <Cell/>
    }

    return (
      <>
        <Table className={classes.spacingTable} size='small'>
          <TableBody>
            <TableRow>
              <Cells data={lineData} columns={columns}/>
            </TableRow>
          </TableBody>
        </Table>
      </>
    )
  }

  const Pagination = props => {
    const [pageInput, setPageInput] = useState(props.page + 1);

    const handlePageInputChange = (event) => {
      setPageInput(event.target.value);
    };
    const handleChangePage = (event, newPage) => {
      console.log(event);
      console.log(newPage);

      props.changePage(newPage);
      props.handleSelected([]);
    };

    const handleChangeRowsPerPage = (event) => {
      props.changeRowsPerPage(props.rowsPerPage === -1 ? handleTotalElements() : parseInt(event.target.value, 10), 0);
      props.changePage(0);
      props.handleSelected([]);
    };

    const handleTotalPages = () => props.handleTotalPages();
    const handleTotalElements = () => props.handleTotalElements();
    const rowsPerPageOptions = props.rowsPerPageOptions ? props.rowsPerPageOptions : [3, 5, 10, 25, 50, 100];

    const handlePageInputSubmit = () => {
      const newPage = Number(pageInput) - 1;
      if (newPage >= 1 && newPage < handleTotalPages()) {
        props.changePage(newPage);
        props.handleSelected([]);
      }
    };

    return (
      <>
        <Grid container spacing={1}>
          <Grid item xs={3} style={{alignSelf: "center"}} >
            <TextField
              type="number"
              value={pageInput}
              onChange={handlePageInputChange}
              min="1"
              max={handleTotalPages()}
              size={"small"}
              style={{width: "110px", marginRight:"5px" }}
            />
            <Button size="small" variant="outlined" onClick={() => handlePageInputSubmit()} style={{fontSize:"0.8rem", fontWeight: 600,}}>Ir para página</Button>
          </Grid>
          <Grid item xs={9} >
            <TablePagination
              labelDisplayedRows={({
                                     from,
                                     to,
                                     count
                                   }) => `Página ${props.page + 1} de ${handleTotalPages()} / Mostrando ${from}-${(to === -1) ? `1` : to} de ${handleTotalElements()} registros`}
              labelRowsPerPage="Linhas Por Página"
              nextIconButtonText="Próxima Página"
              backIconButtonText="Página Anterior"
              nextIconButtonProps={props.loading ? {disabled: props.loading} : {}}
              backIconButtonProps={props.loading ? {disabled: props.loading} : {}}
              rowsPerPageOptions={rowsPerPageOptions}
              component="div"
              count={handleTotalElements() ?? 0}
              rowsPerPage={props.rowsPerPage}
              page={props.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
        </Grid>

      </>
    )
  }

  const ActionCellBody = ({action, id, object}) => {
    if (!action.func) {
      return null
    }

    return (
      <TableCell align="right">
        <Tooltip title={action.name(id, object.original)} TransitionComponent={Zoom}>
        <span style={action.disabled(id, object.original) ? {cursor: 'not-allowed'} : {}}>
          <IconButton
            size="small"
            component="div"
            color={action.color ? (typeof action.color === "function" ? action.color(id, object.original) : action.color) : "primary"}
            aria-label={action.name(id, object.original)}
            onClick={() => action.func(id, object.original)}
            disabled={action.disabled(id, object.original)}
            style={action.disabled(id, object.original) ? {pointerEvents: "none"} : {}}
          >
            {typeof action.icon === "function" ? action.icon(id, object.original) : action.icon}
          </IconButton>
        </span>
        </Tooltip>
      </TableCell>
    )
  }

  const ActionCellHead = ({action}) => {
    if (!action) {
      return null
    }

    return <TableCell align="right"></TableCell>
  }

  const CollapseActions = ({actions, id, object}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClickMenu = (event) => setAnchorEl(event.currentTarget);
    const handleCloseMenu = () => setAnchorEl(null);

    return (
      <TableCell align="right" id={`collapse-actions`}>
        <Tooltip title="Ações" TransitionComponent={Zoom}>
          <IconButton
            size="small"
            component="div"
            color="primary"
            aria-label="Ações"
            onClick={handleClickMenu}
            style={{display: "flex"}}
          >
            <SettingsOutlinedIcon/>
          </IconButton>
        </Tooltip>
        <Menu
          id="collapse-actions-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
        >
          {actions.map((action, key) =>
            !action.disabled(id, object.original) &&
            <MenuItem key={key} onClick={() => action.func(id, object.original)}>
              <IconButton
                size="small"
                component="div"
                color={action.color ? (typeof action.color === "function" ? action.color(id, object.original) : action.color) : "primary"}
                aria-label={action.name(id, object.original)}
                style={{display: "flex", marginRight: "7px"}}
              >
                {typeof action.icon === "function" ? action.icon(id, object.original) : action.icon}
              </IconButton>
              {action.name(id, object.original)}
            </MenuItem>
          )}
        </Menu>
      </TableCell>
    )
  }

  const Sort = ({sort, sortLevel, sizeSort, column, requestSort, clearSort}) => {
    const classes = useStyles();
    const createSortHandler = (property) => (event) => {
      requestSort(event, property);
    };

    const clearSortHandler = (property) => (event) => {
      clearSort(event, property);
    };

    const columnNameSortable = column.filter ?? column.name;

    return (
      <>
        <TableSortLabel
          active={sort ? sort.orderBy === columnNameSortable : false}
          direction={sort && sort.orderBy === columnNameSortable ? sort.order : 'asc'}
          onClick={createSortHandler(columnNameSortable)}
        >
          {column.label}
          {sort && sort.orderBy === columnNameSortable && (
            <span className={classes.visuallyHidden}>
            {sort.order === 'desc' ? 'Ordenação Descendente' : 'Ordenação Ascendente'}
          </span>
          )}
        </TableSortLabel>

        {sort &&
          (sizeSort > 1 && (sortLevel + 1 > 0) ?
              <Chip
                label={sortLevel + 1}
                onDelete={clearSortHandler(columnNameSortable)}
              />
              : <Badge className={classes.badgeTable} anchorOrigin={{vertical: 'top', horizontal: 'left'}}
                       overlap="circular" color="default" badgeContent={sortLevel + 1}/>
          )
        }
      </>
    )
  }

  const columnsFilter = (columns, data) => {
    let array = [];

    if (data !== null) {
      data.forEach(d => {
        const object = {};

        let countIds = 0;
        columns.forEach(c => {
          if (c.key) countIds = countIds + 1;
        })

        object['original'] = d;
        columns.forEach(c => {
          if (c.key) {
            if (countIds > 1) {
              if (object['id'] === undefined) {
                object['id'] = {};
              }

              object['id'][c.name] = d[c.name];
            } else {
              object['id'] = d[c.name];
            }
          }

          object[c.name] = d[c.name];
        })
        array.push(object);
      })
    }

    return array;
  }

  export default DataTable;
